import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Umbrella02 = function Umbrella02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7 19.4C7 20.8359 8.1193 22 9.5 22s2.5-1.1641 2.5-2.6V11m0 0c-1.6102 0-4 1-4 1s-1.3898-1-3-1-3 1-3 1C2 6.4772 6.4772 2 12 2s10 4.4772 10 10c0 0-1.3898-1-3-1s-3 1-3 1-2.3898-1-4-1"
    })
  }));
};
export default Umbrella02;